import { TenantConfig } from '@bling-fe/shared/tenant-config';

export const findTenantConfigByHostname = (
  tenantConfigs: TenantConfig[],
  hostname: string
): TenantConfig | null => {
  const localhostTenantSubdomain = hostname.endsWith('localhost')
    ? hostname.split('.')[0]
    : null;
  return (
    tenantConfigs.find(
      config =>
        config.urls.production.includes(hostname) ||
        config.urls.staging.includes(hostname) ||
        config.subdomain == localhostTenantSubdomain
    ) ?? null
  );
};
